import ProductRangeSelect from './ProductRangeSelect'

export default ProductRangeSelect
